import React from "react";
import { useEngagementStore } from "./store";
import ViewDashboard from "modules/utilities/qa_integration_view_dashboard/ViewDashboard";

const CoachView = () => {
  const {
    coachViewData,
    fetchCoachViewData,
    coachViewDataLoading,
    coachViewFilterData,
    coachViewFilterDataLoading,
    fetchCoachViewFilter,
  } = useEngagementStore();

  const customQueryParams = {
    team: null,
    process: null,
    coachId: null,
  };

  return (
    <ViewDashboard
      title=" Coach View Dashboard"
      fetchData={fetchCoachViewData}
      fetchFilterData={fetchCoachViewFilter}
      filterDataLoading={coachViewFilterDataLoading}
      filterData={coachViewFilterData}
      headers={coachViewData.headers}
      totalRowCount={coachViewData.total_row_count}
      rowsData={coachViewData.rows_data}
      loading={coachViewDataLoading}
      customQueryParams={customQueryParams}
    />
  );
};

export default CoachView;
